import { jsxs as _jsxs } from "react/jsx-runtime";
export const Required = () => {
    var _a;
    const a11yText = ((_a = window === null || window === void 0 ? void 0 : window.I18n) === null || _a === void 0 ? void 0 : _a.t('views.backoffice.required')) || 'required';
    return (_jsxs("span", { style: { marginLeft: '2px' }, title: a11yText, children: [' ', "*"] }));
};
//# sourceMappingURL=Required.js.map